import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";

import {
    useGetAllArchivedCarsQuery,
    useGetAllCarsForOperationArchivedQuery
} from "../../../redux/slices/admin/machine/archivedCarsSlince.js";
import {
    Pagination
} from "@mui/material";

import { useOutletContext } from "react-router-dom";
import "../../../styles/admin.css/machine-modifications-css/archived-cars.css";

export default function ArchivedCars() {
    const { sidebarOpen } = useOutletContext();
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;
    const [plateSearch, setPlateSearch] = useState("");
    const normalize = (v) => (v ?? "").toString().replace(/-/g, "").toLowerCase();
    const { data: logsData, isLoading: logsLoading, refetch: refetchLogs } = useGetAllArchivedCarsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });
    const logs = logsData?.data || [];

    const { data: platesData, isLoading: platesLoading, refetch: refetchPlates } = useGetAllCarsForOperationArchivedQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });
    const plateNumbers = platesData?.data || [];




    React.useEffect(() => {
        refetchLogs();
        refetchPlates();
    }, []);
    const [selectedPlate, setSelectedPlate] = useState("all");

    const filteredLogs = logs.filter(emp => {
        const plateMatch = selectedPlate === "all" || emp.plateNumber === selectedPlate;

        const searchMatch = normalize(emp.plateNumber).includes(normalize(plateSearch));

        return plateMatch && searchMatch;
    });

    const totalPages = Math.ceil(filteredLogs.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedLogs = filteredLogs.slice(startIndex, startIndex + itemsPerPage);

    useEffect(() => {
        setPage(1);
    }, [selectedPlate, plateSearch]);
    return (
        <Box className={`archive-cars-container ${sidebarOpen ? "sidebar-open" : ""}`}>

            <Box className="archive-cars-header">
                <Box className="archive-cars-title">
                    <Typography style={{ color: "#545A61" }}>Arxivləşdirilmiş maşınlar</Typography>
                    <Divider className="archive-cars-divider" />
                </Box>


                <Box className="archive-cars-filter-row">
                    <TextField
                        size="small"
                        placeholder="Axtar..."
                        value={plateSearch}
                        onChange={(e) => setPlateSearch(e.target.value)}
                        sx={{ width: 220, marginRight: 1 }}
                    />

                    <FormControl size="small" className="archive-cars-filter">
                        <InputLabel>Qeydiyat Nişanı</InputLabel>
                        <Select
                            value={selectedPlate}
                            label="Qeydiyat Nişanı"
                            onChange={(e) => setSelectedPlate(e.target.value)}
                            style={{ width: 150 }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 250,
                                        width: 150,
                                    },
                                },
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                },
                                getContentAnchorEl: null,
                            }}
                        >
                            <MenuItem value="all">Hamısı</MenuItem>
                            {!platesLoading && plateNumbers.map((plate, idx) => (
                                <MenuItem key={idx} value={plate.plateNumber}>{plate.plateNumber}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            <TableContainer component={Paper} className="archive-cars-table">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>#No</strong></TableCell>
                            <TableCell><strong>Tam Ad</strong></TableCell>
                            <TableCell><strong>Əlaqə nömrəsi</strong></TableCell>
                            <TableCell><strong>Model</strong></TableCell>
                            <TableCell><strong>Nömrə nişanı</strong></TableCell>
                            <TableCell><strong>Çıxarış tarixi</strong></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {logsLoading ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                            </TableRow>
                        ) : paginatedLogs.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">Məlumat tapılmadı</TableCell>
                            </TableRow>
                        ) : (
                            paginatedLogs.map((emp, index) => (
                                <TableRow key={emp.id}>
                                    <TableCell>{"#" + String(emp.serialNo || emp.id).padStart(4, "0")}</TableCell>
                                    <TableCell>{emp.firstName} {emp.lastName}</TableCell>
                                    <TableCell>+994 {emp.phone}</TableCell>
                                    <TableCell>{emp.model}</TableCell>
                                    <TableCell>{emp.plateNumber}</TableCell>
                                    <TableCell>
                                        {emp.archivedAt
                                            ? new Date(emp.archivedAt).toLocaleString()
                                            : "-"}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {filteredLogs.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    );
}
